import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'

const TaskNotFoundUI = ({context, messageList}) =>
  <div className='g_flex_v g_text_center'>
    <MessageUI messageList={messageList} messageKey='c_task_not_found' />
  </div>

export default TaskNotFoundUI
